var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"works-card-wrap"},[_c('router-link',{attrs:{"to":"services"}},[_c('div',{staticClass:"works-card"},[_c('div',{staticClass:"icon"},[_c('iconic',{attrs:{"name":_vm.icon}})],1),_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"desc"},[_vm._v(_vm._s(_vm.desc))])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }